import { OverlayRef } from '@angular/cdk/overlay';
import { Observable, Subject } from 'rxjs';

export class EditCompanionOverlayRef {
  private _id: string | undefined;
  private _onClose = new Subject<boolean>();
  public constructor(private _overlayRef: OverlayRef) {}

  public close(reload = false): void {
    this._overlayRef.dispose();
    this._onClose.next(reload);
    this._onClose.complete();
  }

  public setId(_id: string): void {
    this._id = _id;
  }

  public getId(): string | undefined {
    return this._id;
  }

  public observeClose(): Observable<boolean> {
    return this._onClose.asObservable();
  }
}
